module.exports = __webpack_public_path__ + "aa7293b22fa34300264e8d1874a15958.hdr";